// Custom Product Slider with Swiper
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('[data-product-slider]');
  if (!sliders.length) {
    return;
  }

  sliders.forEach(function(slider) {
    const sectionId = slider.dataset.sectionId;
    if (!sectionId) {
      return;
    }

    const swiperContainer = slider.querySelector('.swiper-' + sectionId);
    if (!swiperContainer) {
      console.warn(`Swiper container for section ${sectionId} not found`);
      return;
    }

    const slidesPerViewDesktop = parseInt(slider.dataset.slidesPerViewDesktop) || 4;
    const slidesPerViewMobile = parseInt(slider.dataset.slidesPerViewMobile) || 1;
    const spaceBetween = parseInt(slider.dataset.spaceBetween) || 20;
    const gridRows = parseInt(slider.dataset.gridRows) || 2;
    const autoplayDesktop = slider.dataset.autoplayDesktop === 'true';
    const autoplayMobile = slider.dataset.autoplayMobile === 'true';
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay) || 3;
    
    // Determine if autoplay should be enabled based on screen size
    const isMobile = window.innerWidth < 768;
    const shouldAutoplay = (isMobile && autoplayMobile) || (!isMobile && autoplayDesktop);
    
		// DO NOT FORGET update default styles in css and liquid if we change swiper setup here
    const swiperConfig = {
      // Optional parameters
      spaceBetween: spaceBetween,
      
      // Grid layout
      grid: {
        rows: gridRows,
        fill: 'row'
      },

      // Navigation arrows
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next-' + sectionId),
        prevEl: slider.querySelector('.swiper-button-prev-' + sectionId),
      },
      
      // Pagination
      pagination: {
        el: slider.querySelector('.swiper-pagination-' + sectionId),
        clickable: true,
      },
      
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: slidesPerViewMobile,
          grid: {
            rows: 1
          }
        },
        768: {
          slidesPerView: 2,
          grid: {
            rows: gridRows
          }
        },
        1024: {
          slidesPerView: slidesPerViewDesktop,
          grid: {
            rows: gridRows
          }
        }
      }
    };

    // Add autoplay if enabled
    if (shouldAutoplay) {
      swiperConfig.autoplay = {
        delay: autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    // Initialize Swiper
    const swiper = new Swiper(swiperContainer, swiperConfig);
    
    // Mark as initialized
    swiperContainer.classList.add('swiper__initialized');
  }); 
}); 